import {
  IS_FETCHING,
  IS_ERROR,
  IS_SUCCESS,
  SET_DROPDOWN_CATEGORIES,
} from "../actionsTypes";

export const DEFAULT_PAGE_SIZE = 20;

const initialState = {
  isFetching: false,
  error: {
    isError: false,
    message: "",
  },
  isSuccess: false,
  dropdownCategories: [],
  allCategories: {},
};

export const categoryReducer = (state = initialState, action) => {
  if (action.type === IS_FETCHING) {
    return {
      ...state,
      isFetching: action.payload.isFetching,
    };
  }

  if (action.type === IS_ERROR) {
    return {
      ...state,
      error: action.payload,
    };
  }

  if (action.type === IS_SUCCESS) {
    return {
      ...state,
      isSuccess: action.payload.isSuccess,
    };
  }

  if (action.type === SET_DROPDOWN_CATEGORIES) {
    return {
      ...state,
      dropdownCategories: [...action.payload.categories],
    };
  }

  return state;
};
